const saveData = {
  state: {
    saveData:false
  },

  mutations: {
  
    SET_SAVEDATAL: (state,saveData) => {
      state.saveData = saveData;
    }
  },

  actions: {
    
  }
}

export default saveData
